import React from 'react';
import {Form, Segment, Message, Header, Divider, Button, Icon} from 'semantic-ui-react';
import {
  InlineTextBoxField,
  InlineSelect,
  Checkbox,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {isValidDuns} from 'common/utils';
import {Alert} from 'componentLibrary';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import _ from 'lodash';
import SuborgProgram from 'app-ui-componentlibrary/dist/go/components/common/SuborgProgram';
import {createPrefixOptions} from './utils';
import {mapRefDataCode} from 'common/utils';
import REST from 'go/requests/rest';
import {API_CREATE_ORG_FAILURE} from 'common/types';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

const MODAL_OPTIONS = {
  CREATE: 'create',
  NONE: 'none',
  SUCCESS: 'success',
};

let orgPayload = {
  registrationStatus: 'A',
  contacts: [
    {
      prefix: '',
      suffix: '',
      firstName: '',
      middleInitial: '',
      lastName: '',
      title: '',
      email: '',
      usPhone: '',
      usPhoneExtension: '',
      nonUSPhone: '',
      fax: '',
      type: 'ELECTRONIC',
    },
  ],
  addresses: [{type: 'MAILING'}],
  mailingAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    zip: '',
    zipPlus4: '',
    county: '',
    country: '',
    type: 'MAILING',
  },
  physicalAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    zip: '',
    zipPlus4: '',
    county: '',
    country: '',
    type: 'PHYSICAL',
  },
};

class CreateSubOrganizationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      physicalAddressCheck: false,
      refData: {
        salutationType: [],
      },
    };
  }

  componentDidMount() {
    REST.ref
      .getCodelist('PREFIX')
      .then((res) => forceJsonResponse(res, MONO))
      .then((resJson) => {
        let refData = {
          salutationType: mapRefDataCode(resJson.PREFIX),
        };
        this.setState({refData: refData});
      })
      .catch((error) => {
        console.error('error');
      });
  }

  UNSAFE_componentWillMount() {
    if (this.props.orgData) {
      if (this.props.orgData.physicalAddress === null) {
        this.props.orgData.physicalAddress = {
          addressLine1: '',
          addressLine2: '',
          city: '',
          stateOrProvince: '',
          zip: '',
          zipPlus4: '',
          county: '',
          country: '',
          type: 'PHYSICAL',
        };
      }
    }
  }

  handlePhysicalAddressCheck = (e) => {
    this.setState({physicalAddressCheck: !this.state.physicalAddressCheck});
  };

  handleSaveOrganization = async (orgPayload) => {
    const {token, organizationId} = this.props;
    const payload = orgPayload;
    payload.mailingAddress = _.first(_.filter(payload.addresses, {type: 'MAILING'}));
    payload.physicalAddress = _.first(_.filter(payload.addresses, {type: 'PHYSICAL'}));
    let result;
    await this.props.createSubOrganization(token, payload, organizationId).then((res) => {
      res.type === API_CREATE_ORG_FAILURE
        ? this.setState({
            responseErrorMessage:
              'An error occurred while processing your request - please try again.',
          })
        : this.setState({
            openModal: MODAL_OPTIONS.SUCCESS,
            newOrganizationInfo: _.get(res, 'payload.organization'),
          });
      result = res;
    });
    this.props.fetchMoreData({});
    return result;
  };
  render() {
    let {
      title,
      organizationName,
      dunsNumber,
      einNumber,
      city,
      zipCode,
      addressLine1,
      addressLine2,
      stateOrProvince,
      runValidation,
      errorPayload,
      responseErrorMessage,
      isEditable,
      orgData,
      orgId,
      handleInputChange,
      handleMailingAddressChange,
      handlePhysicalAddressChange,
      createOrgPostPayload,
      programs,
      programCheckedList,
      programSelected,
      handlePrograms,
      handleProgramCheckbox,
      handleSelectProgram,
      handleGetAllPrograms,
      isSuborgUpdate,
      isUpdate,
      editMode,
      dunsToUEIToggle,
      useSuborgToggle,
      editSarSection,
      handleSarChange,
      readOnlySarSection,
      editSuborg,
      firstName,
      lastName,
      middleInitial,
      email,
      suffix,
      prefix,
    } = this.props;

    const {physicalAddressCheck} = this.state;
    const salutationOpts = createPrefixOptions(this.state.refData.salutationType);
    return (
      <React.Fragment>
        <Header as="h3" className="suborg-form-header">
          {title}
        </Header>
        <span className="modal-instructions">
          If the suborganization is not registered in SAM.gov, use the form below to enter
          information about the suborganization you would like to add to your
          organization. An email will be sent to the AOR identified to register on FEMA
          GO, if they are not yet registered.
        </span>
        <br />
        <br />
        <br />
        <Form size="small" id="suborgForm">
          <InlineTextBoxField
            displayError={
              (errorPayload && errorPayload.legalBusinessName) ||
              errorPayload.legalBusinessName
            }
            errorMessages={errorPayload.legalBusinessName}
            fluid={true}
            title="Organization name"
            guidance="Organization name"
            id="organizationName"
            name="legalName"
            size="fullscreen"
            value={!isEditable ? organizationName : orgData.legalBusinessName}
            handleChange={
              !isEditable
                ? (e) => {
                    orgPayload.legalBusinessName = e.target.value;
                  }
                : handleInputChange
            }
          />
          <Form.Group widths="equal">
            <InlineTextBoxField
              displayError={
                (errorPayload && errorPayload.dunsNumber) || errorPayload.duns
              }
              errorMessages={errorPayload.dunsNumber || errorPayload.duns}
              fluid={true}
              title={dunsToUEIToggle ? 'DUNS # (optional)' : 'DUNS #'}
              label={
                dunsToUEIToggle ? (
                  <React.Fragment>
                    <strong>DUNS # </strong>
                    <i>(optional)</i>
                  </React.Fragment>
                ) : (
                  <strong>DUNS #</strong>
                )
              }
              id="dunsNumber"
              name="duns"
              size="left"
              value={!isEditable ? dunsNumber : _.join([orgData.duns, orgData.eft], '')}
              handleChange={
                !isEditable
                  ? (e) => {
                      const value = e.target.value;
                      if (isValidDuns(value)) {
                        orgPayload.dunsNumber = value.substring(0, 9);
                        value.length === 13
                          ? (orgPayload.dunsNumberPlus4 = value.substring(9, 13))
                          : (orgPayload.dunsNumberPlus4 = '');
                      } else {
                        orgPayload.dunsNumber = value;
                      }
                    }
                  : handleInputChange
              }
            />
            <InlineTextBoxField
              displayError={errorPayload && errorPayload.ein}
              errorMessages={errorPayload.ein}
              fluid={true}
              title="EIN # (optional)"
              label={
                <React.Fragment>
                  <strong>EIN #</strong>
                  <i> (optional)</i>
                </React.Fragment>
              }
              id="einNumber"
              name="ein"
              size="right"
              value={!isEditable ? einNumber : orgData.ein}
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.ein = e.target.value;
                    }
                  : handleInputChange
              }
            />
          </Form.Group>
          <div className="address-section">
            <strong>Mailing address</strong>
            <br />
            <br />
            <InlineTextBoxField
              displayError={errorPayload.addressLine1}
              errorMessages={errorPayload.addressLine1}
              fluid={true}
              title="Address 1"
              label={<React.Fragment>Address 1</React.Fragment>}
              id="addressLine1"
              name="addressLine1"
              size="fullscreen"
              ref="mailing_address1"
              value={!isEditable ? addressLine1 : orgData.mailingAddress.addressLine1}
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].addressLine1 = e.target.value;
                      orgPayload.mailingAddress.addressLine1 = e.target.value;
                    }
                  : handleMailingAddressChange
              }
            />
            <InlineTextBoxField
              fluid={true}
              title="Address 2 (optional)"
              label={
                <React.Fragment>
                  Address 2<i> (optional)</i>
                </React.Fragment>
              }
              id="addressLine2"
              name="addressLine2"
              size="fullscreen"
              value={!isEditable ? addressLine2 : orgData.mailingAddress.addressLine2}
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].addressLine2 = e.target.value;
                      orgPayload.mailingAddress.addressLine2 = e.target.value;
                    }
                  : handleMailingAddressChange
              }
            />
            <Form.Group widths="equal">
              <InlineTextBoxField
                displayError={errorPayload && errorPayload.city}
                errorMessages={errorPayload.city}
                fluid={true}
                title="City"
                label="City"
                id="city"
                name="city"
                size="left"
                value={!isEditable ? city : orgData.mailingAddress.city}
                handleChange={
                  !isEditable
                    ? (e) => {
                        orgPayload.addresses[0].city = e.target.value;
                        orgPayload.mailingAddress.city = e.target.value;
                      }
                    : handleMailingAddressChange
                }
              />
              <InlineSelect
                displayError={
                  (errorPayload && errorPayload.stateOrProvince) || errorPayload.state
                }
                errorMessages={errorPayload.stateOrProvince || errorPayload.state}
                placeholder="State"
                title="State"
                label="State"
                id="state"
                name="stateOrProvince"
                defaultValue="Select"
                options={STATE_OPTIONS}
                value={
                  !isEditable ? stateOrProvince : orgData.mailingAddress.stateOrProvince
                }
                handleChange={
                  !isEditable
                    ? (e) => {
                        orgPayload.addresses[0].stateOrProvince = e.target.value;
                        orgPayload.mailingAddress.stateOrProvince = e.target.value;
                      }
                    : handleMailingAddressChange
                }
              />
            </Form.Group>
            <InlineTextBoxField
              displayError={errorPayload && errorPayload.zip}
              errorMessages={errorPayload.zip}
              size={'mini'}
              fluid={true}
              title="Zip code"
              label="Zip code"
              id="zipCode"
              name="zip"
              value={!isEditable ? zipCode : orgData.mailingAddress.zip}
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].zip = e.target.value;
                      orgPayload.mailingAddress.zip = e.target.value;
                    }
                  : handleMailingAddressChange
              }
            />
          </div>
          <div className="address-section physical">
            <div id="checkbox-wrapper">
              <strong>Physical address</strong>
              <Checkbox
                className="isPrimary"
                title="Same as mailing address"
                label="Same as mailing address"
                checked={physicalAddressCheck}
                handleChange={this.handlePhysicalAddressCheck}
              />
            </div>
            <InlineTextBoxField
              displayError={
                (errorPayload && errorPayload.physical_addressLine1) ||
                errorPayload.physical_addressLine1
              }
              errorMessages={errorPayload.physical_addressLine1}
              fluid={true}
              title="Address 1"
              label="Address 1"
              id="physical-addressLine1"
              name="addressLine1"
              size="fullscreen"
              value={
                physicalAddressCheck && !isEditable
                  ? (orgPayload.physicalAddress.addressLine1 = _.get(
                      orgPayload.mailingAddress,
                      'addressLine1'
                    ))
                  : physicalAddressCheck && isEditable
                  ? (orgData.physicalAddress.addressLine1 = _.get(
                      orgPayload.mailingAddress,
                      'addressLine1'
                    ))
                  : !isEditable
                  ? addressLine1
                  : orgData.physicalAddress.addressLine1
              }
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].addressLine1 = e.target.value;
                      orgPayload.physicalAddress.addressLine1 = e.target.value;
                    }
                  : handlePhysicalAddressChange
              }
            />
            <InlineTextBoxField
              fluid={true}
              title="Address 2 (optional)"
              label={
                <React.Fragment>
                  Address 2<i> (optional)</i>
                </React.Fragment>
              }
              id="physical-addressLine2"
              name="addressLine2"
              size="fullscreen"
              value={
                physicalAddressCheck && !isEditable
                  ? (orgPayload.physicalAddress.addressLine2 = _.get(
                      orgPayload.mailingAddress,
                      'addressLine2'
                    ))
                  : physicalAddressCheck && isEditable
                  ? (orgData.physicalAddress.addressLine2 = _.get(
                      orgPayload.mailingAddress,
                      'addressLine2'
                    ))
                  : !isEditable
                  ? addressLine2
                  : orgData.physicalAddress.addressLine2
              }
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].addressLine2 = e.target.value;
                      orgPayload.physicalAddress.addressLine2 = e.target.value;
                    }
                  : handlePhysicalAddressChange
              }
            />
            <Form.Group widths="equal">
              <InlineTextBoxField
                displayError={errorPayload && errorPayload.physical_city}
                errorMessages={errorPayload.physical_city}
                fluid={true}
                title="City"
                label="City"
                id="physical-city"
                name="city"
                size="left"
                value={
                  physicalAddressCheck && !isEditable
                    ? (orgPayload.physicalAddress.city = _.get(
                        orgPayload.mailingAddress,
                        'city'
                      ))
                    : physicalAddressCheck && isEditable
                    ? (orgData.physicalAddress.city = _.get(
                        orgPayload.mailingAddress,
                        'city'
                      ))
                    : !isEditable
                    ? city
                    : orgData.physicalAddress.city
                }
                handleChange={
                  !isEditable
                    ? (e) => {
                        orgPayload.addresses[0].city = e.target.value;
                        orgPayload.physicalAddress.city = e.target.value;
                      }
                    : handlePhysicalAddressChange
                }
              />
              <InlineSelect
                displayError={
                  (errorPayload && errorPayload.physical_stateOrProvince) ||
                  errorPayload.physical_state
                }
                errorMessages={
                  errorPayload.physical_stateOrProvince || errorPayload.physical_state
                }
                placeholder="State"
                title="State"
                label="State"
                id="physical-state"
                name="stateOrProvince"
                defaultValue="Select"
                options={STATE_OPTIONS}
                value={
                  physicalAddressCheck && !isEditable
                    ? (orgPayload.physicalAddress.stateOrProvince = _.get(
                        orgPayload.mailingAddress,
                        'stateOrProvince'
                      ))
                    : physicalAddressCheck && isEditable
                    ? (orgData.physicalAddress.stateOrProvince = _.get(
                        orgPayload.mailingAddress,
                        'stateOrProvince'
                      ))
                    : !isEditable
                    ? stateOrProvince
                    : orgData.physicalAddress.stateOrProvince
                }
                handleChange={
                  !isEditable
                    ? (e) => {
                        orgPayload.addresses[0].stateOrProvince = e.target.value;
                        orgPayload.physicalAddress.stateOrProvince = e.target.value;
                      }
                    : handlePhysicalAddressChange
                }
              />
            </Form.Group>
            <InlineTextBoxField
              displayError={errorPayload && errorPayload.physical_zip}
              errorMessages={errorPayload.physical_zip}
              size={'mini'}
              fluid={true}
              title="Zip code"
              label="Zip code"
              id="physical-zipCode"
              name="zip"
              value={
                physicalAddressCheck && !isEditable
                  ? (orgPayload.physicalAddress.zip = _.get(
                      orgPayload.mailingAddress,
                      'zip'
                    ))
                  : physicalAddressCheck && isEditable
                  ? (orgData.physicalAddress.zip = _.get(
                      orgPayload.mailingAddress,
                      'zip'
                    ))
                  : !isEditable
                  ? zipCode
                  : orgData.physicalAddress.zip
              }
              handleChange={
                !isEditable
                  ? (e) => {
                      orgPayload.addresses[0].zip = e.target.value;
                      orgPayload.physicalAddress.zip = e.target.value;
                    }
                  : handlePhysicalAddressChange
              }
            />
          </div>
          {!isEditable || editMode ? (
            <React.Fragment>
              <SuborgProgram
                programs={programs}
                programCheckedList={programCheckedList}
                programSelected={programSelected}
                useSuborgToggle={useSuborgToggle}
                programNameList={this.props.programNameList}
                handlePrograms={handlePrograms}
                handleProgramCheckbox={handleProgramCheckbox}
                handleSelectProgram={handleSelectProgram}
                handleGetAllPrograms={handleGetAllPrograms}
                displayError={errorPayload && errorPayload.programCheckedList}
                errorMessage={errorPayload.programCheckedList}
                editMode={editMode}
                disabledProgramCheckedList={this.props.disabledProgramCheckedList}
              />
              {!this.props.disableAORSection ? (
                <React.Fragment>
                  <Header as="h4" className="aor-title">
                    Suborganization Authorized Representative
                  </Header>
                  <Divider />
                  <Segment size="small" secondary>
                    <InlineSelect
                      label="Salutation (optional)"
                      id="salutationType"
                      name="salutationType"
                      defaultValue="Select"
                      options={salutationOpts}
                      handleChange={
                        editSarSection
                          ? handleSarChange
                          : (e) => {
                              orgPayload.contacts[0].prefix = e.target.value;
                            }
                      }
                      value={
                        !editSuborg
                          ? prefix
                          : _.get(
                              orgData,
                              'organizationContacts[0].organizationContact.contact.prefix',
                              ''
                            )
                      }
                      disabled={readOnlySarSection ? readOnlySarSection : false}
                    />
                    <Form.Group>
                      <InlineTextBoxField
                        displayError={errorPayload && errorPayload.firstName}
                        errorMessages={errorPayload.firstName}
                        fluid
                        label="First name"
                        placeholder="First name"
                        id="firstName"
                        name="firstName"
                        width={10}
                        handleChange={
                          editSarSection
                            ? handleSarChange
                            : (e) => {
                                orgPayload.contacts[0].firstName = e.target.value;
                              }
                        }
                        value={
                          !editSuborg
                            ? firstName
                            : _.get(
                                orgData,
                                'organizationContacts[0].organizationContact.contact.firstName',
                                ''
                              )
                        }
                        disabled={readOnlySarSection ? readOnlySarSection : false}
                      />
                      <InlineTextBoxField
                        fluid
                        label="Middle initial (optional)"
                        id="middleInitial"
                        name="middleInitial"
                        width={6}
                        handleChange={
                          editSarSection
                            ? handleSarChange
                            : (e) => {
                                orgPayload.contacts[0].middleInitial = e.target.value;
                              }
                        }
                        value={
                          !editSuborg
                            ? middleInitial
                            : _.get(
                                orgData,
                                'organizationContacts[0].organizationContact.contact.middleInitial',
                                ''
                              )
                        }
                        disabled={readOnlySarSection ? readOnlySarSection : false}
                      />
                    </Form.Group>
                    <Form.Group>
                      <InlineTextBoxField
                        displayError={errorPayload && errorPayload.lastName}
                        errorMessages={errorPayload.lastName}
                        fluid
                        label="Last name"
                        placeholder="Last name"
                        name="lastName"
                        id="lastName"
                        width={10}
                        handleChange={
                          editSarSection
                            ? handleSarChange
                            : (e) => {
                                orgPayload.contacts[0].lastName = e.target.value;
                              }
                        }
                        value={
                          !editSuborg
                            ? lastName
                            : _.get(
                                orgData,
                                'organizationContacts[0].organizationContact.contact.lastName',
                                ''
                              )
                        }
                        disabled={readOnlySarSection ? readOnlySarSection : false}
                      />
                      <InlineTextBoxField
                        fluid
                        label="Suffix (optional)"
                        placeholder="Suffix"
                        id="suffix"
                        name="suffix"
                        handleChange={
                          editSarSection
                            ? handleSarChange
                            : (e) => {
                                orgPayload.contacts[0].suffix = e.target.value;
                              }
                        }
                        value={
                          !editSuborg
                            ? suffix
                            : _.get(
                                orgData,
                                'organizationContacts[0].organizationContact.contact.suffix',
                                ''
                              )
                        }
                        disabled={readOnlySarSection ? readOnlySarSection : false}
                      />
                    </Form.Group>
                    <InlineTextBoxField
                      displayError={errorPayload && errorPayload.title}
                      errorMessages={errorPayload.title}
                      fluid
                      label="Title"
                      placeholder="Title"
                      id="title"
                      name="title"
                      handleChange={
                        editSarSection
                          ? handleSarChange
                          : (e) => {
                              orgPayload.contacts[0].title = e.target.value;
                            }
                      }
                      value={
                        !editSuborg
                          ? suffix
                          : _.get(
                              orgData,
                              'organizationContacts[0].organizationContact.contact.suffix',
                              ''
                            )
                      }
                      disabled={readOnlySarSection ? readOnlySarSection : false}
                    />
                    <InlineTextBoxField
                      displayError={errorPayload && errorPayload.email}
                      errorMessages={errorPayload.email}
                      fluid
                      label="Email"
                      placeholder="Email"
                      id="email"
                      name="email"
                      handleChange={
                        editSarSection
                          ? handleSarChange
                          : (e) => {
                              orgPayload.contacts[0].email = e.target.value;
                            }
                      }
                      value={
                        !editSuborg
                          ? email
                          : _.get(
                              orgData,
                              'organizationContacts[0].organizationContact.contact.email',
                              ''
                            )
                      }
                      disabled={readOnlySarSection ? readOnlySarSection : false}
                    />
                  </Segment>
                </React.Fragment>
              ) : null}
              {this.props.displayDirectPrograms &&
              _.isArray(this.props.displayDirectPrograms) ? (
                <Message info icon>
                  <Icon name="info circle" size="large" />
                  <Message.Content>
                    <Message.Header>
                      No Suborganization Authorization Representative roles will be
                      created for
                    </Message.Header>
                    {_.map(this.props.displayDirectPrograms, (program, index) => (
                      <li key={index}>{program.programName}</li>
                    ))}
                  </Message.Content>
                </Message>
              ) : null}
              {!isUpdate || isUpdate === undefined ? (
                <Button
                  primary
                  icon
                  id="addSubOrg"
                  title="Add this suborganization"
                  disabled={false}
                  onClick={() => {
                    orgPayload.isManuallyAdded = 'Y';
                    let validation = runValidation(orgPayload, programCheckedList);
                    if (_.isEmpty(validation) === true) {
                      createOrgPostPayload(orgPayload, programCheckedList);
                    }
                  }}
                >
                  Add this suborganization &nbsp;&nbsp;
                  <Icon name="checkmark" fitted />
                </Button>
              ) : (
                <Button
                  primary
                  icon
                  id="addSubOrg"
                  title="Update this suborganization"
                  disabled={false}
                  onClick={() => {
                    orgPayload.isManuallyAdded = 'Y';
                    let validation = runValidation(orgPayload, programCheckedList);
                    if (_.isEmpty(validation) === true) {
                      createOrgPostPayload(
                        orgPayload,
                        programCheckedList,
                        this.props.programNameList
                      );
                    }
                  }}
                >
                  Update this suborganization &nbsp;&nbsp;
                  <Icon name="checkmark" fitted />
                </Button>
              )}
            </React.Fragment>
          ) : (
            <Button
              primary
              icon
              id="updateSubOrg"
              title="Save changes"
              disabled={false}
              onClick={() => {
                orgPayload.isManuallyAdded = 'Y';
                let validation = runValidation(orgPayload);
                if (_.isEmpty(validation) === true) {
                  createOrgPostPayload(orgPayload, programCheckedList);
                }
              }}
            >
              Save changes &nbsp;&nbsp;
              <Icon name="checkmark" fitted />
            </Button>
          )}

          {responseErrorMessage ? (
            <Alert
              size="tiny"
              header={responseErrorMessage}
              type="error"
              dismissable={false}
            />
          ) : (
            ''
          )}
        </Form>
      </React.Fragment>
    );
  }
}

export default CreateSubOrganizationForm;
